import { motion } from "framer-motion";

export function Reveal({ children, delay = 0, className = "" }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.6, delay, ease: [0.22, 1, 0.36, 1] }}
      className={className}
    >
      {children}
    </motion.div>
  );
}

export function Eyebrow({ children, dark }) {
  return (
    <div className="flex items-center gap-3 mb-4">
      <span className="w-8 h-px bg-[#d4af37]" />
      <span className={`text-[11px] tracking-luxe uppercase ${dark ? "text-[#d4af37]" : "text-[#b5952f]"}`}>{children}</span>
    </div>
  );
}

export function DemoBadge() {
  return <span className="inline-block text-[10px] tracking-widest bg-[#d4af37]/15 text-[#b5952f] border border-[#d4af37]/40 px-2 py-0.5 rounded-sm">DEMO DATA</span>;
}

import { ShieldCheck } from "lucide-react";
export function InsuranceBadges({ site, dark }) {
  if (!site?.insurance?.active) return null;
  return (
    <div className="mt-8" data-testid="insurance-badges">
      <div className="flex items-center gap-3 mb-4">
        <ShieldCheck className="text-[#d4af37]" size={18} />
        <span className="text-[11px] tracking-luxe uppercase text-[#b5952f]">Insured &amp; Protected</span>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
        {site.insurance.claims.map((c) => (
          <div key={c} className={`text-sm rounded-sm px-4 py-3 border ${dark ? "border-[#333] text-[#e8e5de]" : "border-[#e0ddd4] text-[#333]"}`}>
            {c}
          </div>
        ))}
      </div>
    </div>
  );
}
